import { createContext } from 'react';

const YoutrackIssuesTypeContext = createContext({ services: [] });

export default YoutrackIssuesTypeContext;
